// src/utils/tokenService.js
import { useAuthStore } from "@/stores/authStore";

export const getAccessToken = () => {
  const store = useAuthStore();
  return store.accessToken;
};
